import { cardSrc } from './resultParsers';

const PLAYERS = ['Player 8', 'Player 9', 'Player 10', 'Player 11'];
const BASE_POINTS = [8, 9, 10, 11];
const NUM_PLAYERS = 4;

// 32 Cards score: A=1, J=11, Q=12, K=13, number = face value (base points ke saath)
function cardScore(code) {
  if (!code || code === '1' || code === '0') return 0;
  const rank = code.slice(0, -2).toUpperCase();
  if (rank === 'A') return 1;
  if (rank === 'J') return 11;
  if (rank === 'Q') return 12;
  if (rank === 'K') return 13;
  const n = parseInt(rank, 10);
  return isNaN(n) ? 0 : n;
}

// round-robin: player p gets card indices p, p+4, p+8, ... (break on empty)
function getPlayerCards(codes, playerIdx) {
  const cards = [];
  for (let i = playerIdx; i < codes.length; i += NUM_PLAYERS) {
    const c = codes[i];
    if (!c || c === '1' || c === '0') break;
    cards.push(c);
  }
  return cards;
}

export default function Card32EUResult({ detail }) {
  const codes = (detail?.card || '').split(',').map((s) => s.trim()).filter(Boolean);

  const playerCards = PLAYERS.map((_, i) => getPlayerCards(codes, i));
  const scores = playerCards.map((cards, i) =>
    BASE_POINTS[i] + cards.reduce((sum, c) => sum + cardScore(c), 0)
  );

  const winnat = detail?.winnat || '';
  const winValue = detail?.win;
  let winnerIdx = winnat ? PLAYERS.findIndex((p) => winnat === p) : -1;
  if (winnerIdx < 0 && winValue != null && winValue !== '') winnerIdx = Number(winValue) - 1;

  // rdesc = "<winner>#<oddEven line1 ~ line2>#<Black/Red>#<Total>#<Single>"
  const parts = String(detail?.rdesc || '').split('#');
  const oddEven = (parts[1] || '').split('~');
  const rdesc = {
    oddEven1: oddEven[0] || '',
    oddEven2: oddEven[1] || '',
    blackRed: parts[2] || '',
    total: parts[3] || '',
    single: parts[4] || '',
  };

  return (
    <div className="row row5 card32result">
      <div className="col-12 col-lg-8">
        <div className="row row5">
          {PLAYERS.map((name, i) => {
            const isWinner = i === winnerIdx;
            return (
              <div key={i} className="col-12 col-lg-12">
                <div className="casino-result-cards">
                  <h4 className="text-center d-inline-block">
                    {name} -
                    {' '}
                    <span className="badge badge-success font14">{scores[i]}</span>
                  </h4>
                  {' '}
                  {playerCards[i].map((code, j) => (
                    <div key={j} className="casino-result-cards-item">
                      <img src={cardSrc(code)} alt={code} />
                    </div>
                  ))}
                  {isWinner && (
                    <>
                      {' '}
                      <div className="casino-result-cards-item">
                        <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="col-12 col-lg-4">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            <div>{winnat || (winnerIdx >= 0 ? PLAYERS[winnerIdx] : '')}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Odd/Even</div>
            <div>{rdesc.oddEven1}</div>
          </div>
          <div className="casino-result-desc-item">
            <div></div>
            <div>{rdesc.oddEven2}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Black/Red</div>
            <div>{rdesc.blackRed}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Total</div>
            <div>{rdesc.total}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Single</div>
            <div>{rdesc.single}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
